// Icon reprezentativ pentru tipul fișierului: PDF, imagine, sau document fără fișier.
// Returnează un SVG de dimensiune configurabilă prin size (default 40).

function PdfIcon({ size }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 4h20l10 10v26a4 4 0 0 1-4 4H10a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4z" fill="#FFF5F5" stroke="#D14343" strokeWidth="1.5"/>
      <path d="M30 4v10h10" stroke="#D14343" strokeWidth="1.5"/>
      <rect x="11" y="27" width="26" height="13" rx="2" fill="#D14343"/>
      <text x="24" y="37" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="700" fontSize="8" fill="#ffffff">PDF</text>
    </svg>
  );
}

function ImageIcon({ size }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="6" y="8" width="36" height="32" rx="3" fill="#FFE5DC" stroke="#FF6B45" strokeWidth="1.5"/>
      <circle cx="16" cy="18" r="3" fill="#FF6B45"/>
      <path d="M10 34l10-10 8 8 4-4 8 8v2a2 2 0 0 1-2 2H12a2 2 0 0 1-2-2v-4z" fill="#FF6B45"/>
    </svg>
  );
}

function DocIcon({ size }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 4h20l10 10v26a4 4 0 0 1-4 4H10a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4z" fill="#F5F0E8" stroke="#6B7A80" strokeWidth="1.5"/>
      <path d="M30 4v10h10" stroke="#6B7A80" strokeWidth="1.5"/>
      <line x1="14" y1="22" x2="32" y2="22" stroke="#6B7A80" strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="14" y1="28" x2="32" y2="28" stroke="#6B7A80" strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="14" y1="34" x2="24" y2="34" stroke="#6B7A80" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  );
}

export function FileTypeIcon({ kind, size = 40 }) {
  if (kind === 'pdf') return <PdfIcon size={size} />;
  if (kind === 'image') return <ImageIcon size={size} />;
  return <DocIcon size={size} />;
}
